import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import Social from '../componentes/Social'

class MenuContent extends Component {
	render() {
		return (
			<div className="w-menu">
                <ul>
                    <li>
                        <NavLink exact activeClassName="current" to={'/'} onClick={this.props.closeCallback}>Inicio</NavLink>
                    </li>
                    <li>
                        <NavLink exact activeClassName="current" to={'/nosotros'} onClick={this.props.closeCallback}>Nosotros</NavLink>
                    </li>
                    <li>
                        <NavLink exact activeClassName="current" to={'/dormitorios'} onClick={this.props.closeCallback}>Dormitorios</NavLink>
                    </li>
                    <li>
                        <NavLink exact activeClassName="current" to={'/contacto'} onClick={this.props.closeCallback}>Contacto</NavLink>
                    </li>
                </ul>
                <Social />
			</div>
		)
	}
}

export default MenuContent